import { useEffect } from "react";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";
import EmptyModal from "../../components/modals/EmptyModal";
import CreateNewWorkOrderForm from "../../components/forms/workOrders/CreateNewWorkOrderForm";

import { useParams } from "react-router-dom";
import { WorkOrderDetailsViewModel } from "../../viewmodels/workOrders/WorkOrderDetailsViewModel";

function WorkOrderDetails(props) {
  const { addSnackbar, logout } = props;

  const { id } = useParams();

  const {
    customers,
    getCustomersForDropdown,
    employeeOptions,
    getEmployeesForDropdown,
    services,
    getServicesForDropdown,
    getWorkOrder,
    setEmptyModelOpen,
    emptyModal,
    showErrorModal,
    updateWorkOrderApiCall,
    workOrder,
    addServiceToOrderCall,
    askEditOrderItem,
    askDeleteOrderItem,
    onItemEditComplete,
    printWorkOrder,
    openAddNewMakeModal,
    removeImageAtIndexCall,
    uploadNewImageCall,
    emailInvoice,
    emailWoInProgress,
    updateImageTitle,
    updateImageTitleInProgress,
  } = WorkOrderDetailsViewModel(logout, id, addSnackbar);

  useEffect(() => {
    getCustomersForDropdown();
    getEmployeesForDropdown();
    getServicesForDropdown();
    getWorkOrder();
  }, []);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        <div className="sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-xl font-semibold leading-6 text-gray-900">
              Work order: {workOrder.work_number}
            </h1>
          </div>
          <div className="mt-5">
            <CreateNewWorkOrderForm
              customers={customers}
              employeeOptions={employeeOptions}
              isEdit={true}
              loading={false}
              showErrorModal={showErrorModal}
              workOrder={workOrder}
              services={services}
              actionCall={updateWorkOrderApiCall}
              setEmptyModelOpen={setEmptyModelOpen}
              addServiceToOrderCall={addServiceToOrderCall}
              askEditOrderItem={askEditOrderItem}
              askDeleteOrderItem={askDeleteOrderItem}
              onItemEditComplete={onItemEditComplete}
              printWorkOrder={printWorkOrder}
              openAddNewMakeModal={openAddNewMakeModal}
              removeImageAtIndexCall={removeImageAtIndexCall}
              uploadNewImageCall={uploadNewImageCall}
              emailInvoice={emailInvoice}
              emailWoInProgress={emailWoInProgress}
              updateImageTitle={updateImageTitle}
              updateImageTitleInProgress={updateImageTitleInProgress}
            />
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WorkOrderDetails)
);
